// File: frontend/src/components/ai/AgentStatsCards.js

import React from 'react';
import { Bot, CheckCircle, Rocket } from 'lucide-react';
import styles from './AgentStatsCards.module.css';

const AgentStatsCards = ({ stats, isLoading }) => {
  if (isLoading) {
    return (
      <div className={styles.statsGrid}>
        {[1, 2, 3].map((i) => (
          <div key={i} className={`${styles.statCard} ${styles.loading}`}>
            <div className={styles.skeletonIcon}></div>
            <div className={styles.skeletonText}></div>
            <div className={styles.skeletonValue}></div>
          </div>
        ))}
      </div>
    );
  }

  if (!stats) return null;

  const cards = [
    {
      label: 'Total Agents',
      value: stats.total_agents || 0,
      detail: `${stats.active_agents || 0} active`,
      icon: Bot,
      color: 'primary'
    },
    {
      label: 'Deployed',
      value: stats.deployed_agents || 0,
      detail: `${stats.by_deployment_status?.deployed || 0} in production`,
      icon: Rocket,
      color: 'success'
    },
    {
      label: 'Active',
      value: stats.active_agents || 0,
      detail: `${stats.by_status?.active || 0} ready to use`,
      icon: CheckCircle,
      color: 'info'
    }
  ];

  return (
    <div className={styles.statsGrid}>
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <div key={index} className={styles.statCard}>
            <div className={`${styles.iconWrapper} ${styles[`icon${card.color.charAt(0).toUpperCase() + card.color.slice(1)}`]}`}>
              <Icon size={20} />
            </div>
            <div className={styles.statContent}>
              <div className={styles.statLabel}>{card.label}</div>
              <div className={styles.statValue}>{card.value.toLocaleString()}</div>
              <div className={styles.statDetail}>{card.detail}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AgentStatsCards;